import {UserModel} from "./models/UserModel";
import {MenuItem} from "primeng/api";
import {Project} from "../types/sherpa";
import {Subject} from "rxjs";

export interface Globals {
	activeProject: Project;
	loader: AppLoader;
	loginUser: UserModel | null;
	disableLoader: Function;
	enableLoader: Function;
	requestedUrl: string;
	loginModal: boolean;
	menu: boolean;
	hideAll: boolean;
	menuItems: MenuItem[];
	projectSubject: Subject<Project>;
}

export enum AppLoader {
	PAGE = 'PAGE',
	NONE = 'NONE'
}